const _listeners = new Map();

const EventManager = {
  on(name, cb) {
    if (!_listeners.has(name)) _listeners.set(name, new Set());
    _listeners.get(name).add(cb);
  },
  off(name, cb) {
    const set = _listeners.get(name);
    if (set) set.delete(cb);
  },
  emit(name, data) {
    const set = _listeners.get(name);
    if (set) set.forEach(cb => cb(data));
  },
};

export { EventManager };
